import React from 'react';
import AtlasV2ComparableSplineChart from 'src/components/AtlasV2Components/AtlasV2graphs/AtlasV2ComparableSplineChart';

const AtlasV2PricesSummarySplineChart = () => {
  return <AtlasV2ComparableSplineChart indexName="sales" fieldName="retailPrice" />;
};

export default AtlasV2PricesSummarySplineChart;
